module.exports = __webpack_public_path__ + "static/media/resume.4abc30af.pdf";